import { useSelector } from 'core/use-cases/utilities/';

import type { Content } from 'core/domains';
import type { SelectorReturnFn } from 'core/use-cases/utilities';

/**
 * Selects the content based on the page type
 *
 */

export function useContentSelector(pageType = ''): SelectorReturnFn<Content[number]['data']> {
  const {
    data = {} as Content[number]['data'],
    status,
    updatedAt = 0,
  } = useSelector((state) => state.content[pageType]) || {};

  return {
    data,
    status,
    updatedAt,
  };
}
